module.exports = __webpack_public_path__ + "static/media/52.64b880fe.png";